import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[UI ErrorBoundary]", error, info);
  }
  reset = () => {
    this.setState({ hasError: false, error: null });
  };
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center px-6">
          <div className="max-w-md text-center">
            <div className="text-3xl font-semibold tracking-tight">Something broke here</div>
            <p className="text-neutral-600 mt-2 text-sm">
              {String(this.state.error?.message || this.state.error || "Unknown error")}
            </p>
            <button
              onClick={this.reset}
              className="mt-4 inline-flex items-center px-4 py-2 rounded-lg bg-neutral-900 text-white text-sm"
              data-testid="error-boundary-retry"
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
